import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import { t } from 'i18next';
import { useCallback, useEffect, useRef, useState } from 'react'
// import DataGridWrapper from '@/core/wrappers/data-grid-wrapper'; 
import DataGridWrapper from '@/projects/syncflow/components/data-grid-wrapper';
import CustomStore from 'devextreme/data/custom_store';
import React from 'react';
import { Button } from 'devextreme-react/button';
import { DataGrid, Lookup, Popup, SelectBox } from 'devextreme-react';
import { SelectBoxTypes } from 'devextreme-react/cjs/select-box';
import { forecastService } from '../services/forecast-service';
import ArrayStore from 'devextreme/data/array_store';
import {
    Chart,
    Series,
    ArgumentAxis,
    CommonSeriesSettings,
    Export,
    Legend,
    Margin,
    Title,
    Subtitle,
    Tooltip,
    Grid,
} from 'devextreme-react/chart';
import LookupCombo from '../components/lookup_combo';
import { number } from 'yup';


const ForecastList = () => {

    const luForecastPeriods = useRef<any>(null);
    const luForecastGroups = useRef<any>(null);
    const lu_salechannels = useRef<any>(null);
    const lu_locations = useRef<any>(null);
    const lu_productcategories = useRef<any>(null);



    let LocationTypeCode :string='S';
    let ForecastPeriod:number=0;
    let ForecastGroupCode: string;
    let SaleChannelCode: string;
    let ProductCategoryCode: string;

    let LocationCode: any;

    const dataGridRef = useRef<DataGrid>(null);
    const [store, setStore] = useState<CustomStore>();

    useEffect(() => {       
        luForecastPeriods.current?.refresh({LocationTypeCode:LocationTypeCode});
        setStore(new CustomStore({
            key: ["headerId","productCode"],
            load: onGetOrderData,
            useDefaultSearch: true
        }));
    }, []);
   
    const onLuForecastPeriodsChanged=useCallback(async (e:any) => {
        ForecastPeriod=e;
        if(e ==null)
        {
            luForecastGroups.current.clear();
        }
        else
        {
            luForecastGroups.current.refresh(
                {
                    LocationTypeCode:LocationTypeCode,
                    ForecastPeriod:ForecastPeriod
                });
        }
    }, []);
    const onLuForecastGroupChanged=useCallback(async (e:any) => {
        ForecastGroupCode=e;
        
        if(e ==null)
        {
            lu_salechannels.current.clear();
        }
        else
        {
            lu_salechannels.current.refresh({
                LocationTypeCode:LocationTypeCode,
                ForecastPeriod:ForecastPeriod,
                ForecastGroupCode:ForecastGroupCode
            });
        }
    }, []);
    const onLuSaleChannelsChanged=useCallback(async (e:any) => {
        SaleChannelCode=e;
        if(e ==null)
        {
            lu_locations.current.clear();
        }
        else
        {
        lu_locations.current.refresh(
            {
                LocationTypeCode:LocationTypeCode,
                ForecastPeriod:ForecastPeriod,
                ForecastGroupCode:ForecastGroupCode, 
                SaleChannelCode:SaleChannelCode
            });
        }
    }, []);
    
    const onLuLocationChanged=useCallback(async (e:any) => {
        LocationCode=e;
        if(e ==null)
        {
            lu_productcategories.current.clear();
        }
        else
        {
        lu_productcategories.current.refresh(
            {
                LocationTypeCode:LocationTypeCode,
                ForecastPeriod:ForecastPeriod,
                ForecastGroupCode:ForecastGroupCode,
                SaleChannelCode:SaleChannelCode,
                LocationCode:LocationCode
            });
        }
    }, []);

     const onLuProductCategoriesChanged=useCallback(async (e:any) => {
        ProductCategoryCode=e;
    }, []);
    


    const onGetOrderData = useCallback(async () => {
        if (LocationCode && !popupVisible) {
            const x = await forecastService.getForecastList(
                {
                    LocationTypeCode:LocationTypeCode,
                    ForecastPeriod:ForecastPeriod,
                    ForecastGroupCode:ForecastGroupCode,
                    SaleChannelCode:SaleChannelCode,
                    LocationCode:LocationCode,
                    ProductCategoryCode:ProductCategoryCode
                });
                for(var i=0;i<x.details.length;i++)
                {
                    x.details[i]['periodTypeCode']=x.header.periodTypeCode;
                }
            return x.details;
        }

    }, []);

    const onQuery = useCallback(async () => {
        dataGridRef.current?.instance.refresh();
    }, []);

    const onFocusedCellChanging = (e: { isHighlighted: boolean; }) => {
        e.isHighlighted = true;
    };

 
     const [popupVisible, setPopupVisible] = useState(false);
        const showInfo = useCallback((e: any) => {
            setPopupVisible(true);
        }, [setPopupVisible]);
    
        const hideInfo = useCallback(() => {
            setPopupVisible(false);
        }, [setPopupVisible]);
      

 
    const [dschartyears, setdshartyears] = useState<any[]>();
    const [dschartsales, setdschartsales] = useState<ArrayStore>();

    const goToDetail = (headerId:number,productCode: string) => {
        forecastService.getForecastDetailList(headerId, productCode).then(
            x => {
                var inputs = x.inputs;
                var chartsales: any[]= [];
                var chartyears: any[] = [];
                chartyears.push('Forecast');
                for (var i=0, l=inputs.length; i<l; i++)
                {
                    var year=inputs[i].yearWeek.toString().substring(0,4);
                    if (chartyears.indexOf(year) === -1)
                    {
                        chartyears.push(year);
                    }
                }
                for (let k=1;k<=52;k++)
                {
                    var item:any={Week:k.toString().padStart(2,"0")};
                    for(let l=0;l<chartsales.length;l++)
                    {
                        item["SaleOf"+chartsales[l]]=null;
                    }   
                    chartsales.push(item);                         
                }
                inputs.forEach((e: any) => {
                    var year=e.yearWeek.toString().substring(0,4);
                    var week=parseInt(e.yearWeek.toString().substring(4,6));
                    chartsales[week-1]["SaleOf"+year]=e.saleQty;
                });
                x.results.forEach((e: any) => {
                    var year=e.yearWeek.toString().substring(0,4);
                    var week=parseInt(e.yearWeek.toString().substring(4,6));
                    chartsales[week-1]["SaleOfForecast"]=e.forecastQty;
                });
                setdschartsales(new ArrayStore({data:chartsales}));
                setdshartyears (chartyears) 

                showInfo(0);
            }
        );
    };



    return (
        <>
            <div className='row mb-4 justify-content-end'>
                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_list")}
                        type="default"
                        icon="refresh"
                        onClick={onQuery}
                    />
                </div>
            </div>

            <div className="row col-lg-16">
            <LookupCombo ref={luForecastPeriods} 
                title={'*' + t("syncflow:lb_forecast_week")} 
                name='lu_forecastperiods"'
                onvaluechange={onLuForecastPeriodsChanged}
                api_url={forecastService.url_lu_forecastperiods}>
            </LookupCombo>
           <LookupCombo ref={luForecastGroups} 
                title={'*' + t("syncflow:lb_forecast_group")} 
                name='lu_forecastgroups"'
                onvaluechange={onLuForecastGroupChanged}
                api_url={forecastService.url_lu_forecastgroups}>
            </LookupCombo>
            <LookupCombo ref={lu_salechannels} 
                title={'*' + t("syncflow:lb_sale_channel")} 
                name='lu_salechannels"'
                onvaluechange={onLuSaleChannelsChanged}
                api_url={forecastService.url_lu_salechannels}>
            </LookupCombo>

             <LookupCombo ref={lu_locations} 
                title={'*' + t("syncflow:location")} 
                name='lu_location"'
                onvaluechange={onLuLocationChanged}
                api_url={forecastService.url_lu_location}>
            </LookupCombo>  
             <LookupCombo ref={lu_productcategories}
                title={t("syncflow:lb_product_category")} 
                name='lu_productcategories"'
                onvaluechange={onLuProductCategoriesChanged}
                api_url={forecastService.url_lu_productcategories}>
            </LookupCombo>
            </div>



            <React.Fragment>
                <DataGridWrapper
                    props={{ ref: dataGridRef }}
                    datasource={store}
                    remoteOperations={false}
                    showColumnLines={true}
                    columnChooser={true}
                    pagerVisible={true}
                    filterVisible={true}
                    headerFilterVisible={true}
                    keyboardNavigation={true}
                    excellExport={true}
                    onFocusedCellChanging={onFocusedCellChanging}
                    editingConfig={{
                        mode: "batch",
                        useIcons: true,
                        allowAdding: false,
                        allowDeleting: false,
                        allowUpdating: false,
                        updateMessageText: RemoveMessage('Resource'),
                    }}
                    summary={[
                            {column:'saleQty',summaryType :'sum'}, 
                            {column:'forecastQty',summaryType :'sum'}, 
                            {column:'forecastAmount',summaryType :'sum'}, 
                            {column:'saleAmount',summaryType :'sum'}, 
                            {column:'accuracy',summaryType :'avg'}
                    ]}  
                    columns={[
                        {
                            dataField: 'headerId',
                            caption: t('syncflow:lb_forecast_group'),
                            allowFiltering: false,
                            allowEditing: false,
                            visible:false,
                        },
                        /*{
                            dataField: 'forecastGroup',
                            caption: t('syncflow:lb_forecast_group'),
                            allowFiltering: true,
                            allowEditing: false,
                            visible:false,
                            cellRender: forecast_group_render,                            
                        },
                        
                        {
                            dataField: 'location',
                            caption: t('syncflow:location_code'),
                            allowFiltering: true,
                            allowEditing: false,
                            visible:false,
                        },
                        {
                            dataField: 'locationName',
                            caption: t('syncflow:location'),
                            allowFiltering: true,
                            allowEditing: false,
                            visible:false,
                        },
                        {
                            dataField: 'week',
                            caption: t('syncflow:lb_week'),
                            allowFiltering: true,
                            allowEditing: false,
                            visible:false,
                        },
                        */
                        {
                            dataField: 'productCode',
                            caption: t('syncflow:lb_product_code'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'productName',
                            caption: t('syncflow:lb_product_name'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'forecastQty',
                            caption: t('syncflow:lb_forecast'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                         {
                            dataField: 'forecastAmount',
                            caption: t('syncflow:lb_forecast_amount'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'saleQty',
                            caption: t('syncflow:lb_realized'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'saleAmount',
                            caption: t('syncflow:lb_sale_amount'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'accuracy',
                            caption: t('syncflow:lb_percentage'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'segmentLabel',
                            caption: t('syncflow:lb_product_segment'),
                            allowFiltering: true,
                            allowEditing: false,
                            visible:false,
                        },
                        {
                            dataField: 'forecastMethodLabel',
                            caption: t('syncflow:lb_forecast_method'),
                            allowFiltering: true,
                            allowEditing: false,
                            visible:true,
                        },
                        
                        {
                            dataField: 'seasonalityLabel',
                            caption: t('syncflow:lb_seasonal'),
                            allowFiltering: true,
                            allowEditing: false,
                            visible:false,
                        },
                        {
                            dataField: 'specialDayLabel',
                            caption: t('syncflow:lb_special_day_effect'),
                            allowFiltering: true,
                            allowEditing: false,
                            visible:false,
                        },
                        {
                            dataField: 'periodTypeCode',
                            caption: t('syncflow:lb_period_type'),
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: forecast_period_type_render,
                        },
                        {
                            dataField: 'saleQty1',
                            caption:  "-1 " + t('syncflow:lb_period'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'saleQty2',
                            caption: "-2 " + t('syncflow:lb_period'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'saleQty3',
                            caption: "-3 " + t('syncflow:lb_period'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'saleQty4',
                            caption: "-4 " + t('syncflow:lb_period'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            caption: t('syncflow:lb_detail'),
                            allowFiltering: true,
                            allowEditing: false,
                            cellRender: (data: any) => {
                                return (
                                    <Button
                                        text={t("syncflow:btn_detail")}
                                        type="default"
                                        icon='showpanel'
                                        stylingMode="contained"
                                        onClick={() => goToDetail(data.key.headerId, data.key.productCode)}
                                    />
                                );
                            },
                        }
                    ]}
                />
            </React.Fragment>
            <Popup
                visible={popupVisible}
                onHiding={hideInfo}
                title={t('syncflow:ti_sale_details')}
                showTitle={true}
                width={1200}
                height={600}
                position={{
                    of: window, // Pencereye göre konumlandır
                    at: 'center', // Ortala
                    my: 'center' // Kendi merkezini kullan
                }} >

                <Chart id="chart" title="" dataSource={dschartsales}>
                    <CommonSeriesSettings type="line" argumentField="Week">
                    </CommonSeriesSettings>
                    {dschartyears?.map((item: any) => (
                        <Series key={ "SaleOf" +item} valueField={"SaleOf" +item} name={item} />
                    ))}
                    <ArgumentAxis valueMarginsEnabled={false} discreteAxisDivisionMode="crossLabels">
                        <Grid visible={true} />
                    </ArgumentAxis>
                    <Legend
                        verticalAlignment="top"
                        horizontalAlignment="center"
                        itemTextPosition="right"
                    />
                    <Export enabled={true} />                    
                    <Tooltip enabled={true} />
                </Chart>
            </Popup>
        </>

    )
}
const forecast_group_render = (data: any) => (t('syncflow:lb_forecast_group_' + data.row.data.forecastGroup));
const forecast_period_type_render = (data: any) => (t('syncflow:lb_forecast_period_type_' + data.row.data.periodTypeCode));

export default ForecastList